var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellationRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33561",
    "data-name": "Group 33561",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#ffebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(1590 110.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38167",
    "data-name": "Group 38167",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38166",
    "data-name": "Group 38166",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58489",
    "data-name": "Path 58489",
    d: "M13.66,2.41a8,8,0,1,0,0,11.319A8.011,8.011,0,0,0,13.66,2.41Zm-.876,10.443a6.763,6.763,0,1,1,0-9.566A6.769,6.769,0,0,1,12.784,12.852Z",
    transform: "translate(0 -0.07)",
    fill: "#fc4747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38169",
    "data-name": "Group 38169",
    transform: "translate(5.226 5.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38168",
    "data-name": "Group 38168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58490",
    "data-name": "Path 58490",
    d: "M172.683,169.377l-1.755-1.753,1.755-1.753a.62.62,0,1,0-.876-.877l-1.756,1.754-1.756-1.754a.62.62,0,1,0-.876.877l1.755,1.753-1.755,1.753a.62.62,0,0,0,.876.877l1.756-1.754,1.756,1.754a.62.62,0,1,0,.876-.877Z",
    transform: "translate(-167.236 -164.813)",
    fill: "#fc4747"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellationRequest);
export default __webpack_public_path__ + "static/media/CancellationRequest.9ae5e413.svg";
export { ForwardRef as ReactComponent };